module.exports = __webpack_public_path__ + "static/img/coins.6cb9dcad.png";